/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface EventPlaceDTO
 */
export interface EventPlaceDTO  {
    /**
     * 
     * @type {number}
     * @memberof EventPlaceDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof EventPlaceDTO
     */
    eventPlace?: string;
}

/**
 * Check if a given object implements the EventPlaceDTO interface.
 */
export function instanceOfEventPlaceDTO(value: object): value is EventPlaceDTO {
    return true;
}

export function EventPlaceDTOFromJSON(json: any): EventPlaceDTO {
    return EventPlaceDTOFromJSONTyped(json, false);
}

export function EventPlaceDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventPlaceDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'eventPlace': json['eventPlace'] == null ? undefined : json['eventPlace'],
    };
}

export function EventPlaceDTOToJSON(json: any): EventPlaceDTO {
    return EventPlaceDTOToJSONTyped(json, false);
}

export function EventPlaceDTOToJSONTyped(value?: EventPlaceDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'eventPlace': value['eventPlace'],
    };
}


